module.exports = __webpack_public_path__ + "static/media/yellow-template-big.2d8f5915.png";